import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import {
  catchError,
  concatMap,
  map,
  switchMap,
  withLatestFrom
} from "rxjs/operators";
import { AbstractPeopleService } from "src/app/interfaces";
import { Notification } from "src/app/notifications/notification";
import { NotificationActions } from "src/app/notifications/state/actions";
import { selectPersonByLogin } from ".";
import { PersonAPIActions } from "./actions";

@Injectable()
export class PersonEffects {
  constructor(
    private actions$: Actions,
    private service: AbstractPeopleService,
    private store: Store
  ) {}

  loadPersonByLogin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PersonAPIActions.loadPersonByLogin),
      concatMap((action) =>
        of(action).pipe(
          withLatestFrom(this.store.select(selectPersonByLogin(action.login))), //Get person if exist in store
          switchMap(([action, personFromStore]) => {
            if (personFromStore) {
              return of(
                PersonAPIActions.loadPersonByLoginNotNecessary({
                  person: personFromStore
                })
              );
            }

            return this.service.GetPerson(action.login).pipe(
              map((person) => {
                if (!person.id) {
                  person.id = person.login; //Fallback - working if ID exist.
                }
                return PersonAPIActions.loadPersonByLoginSuccess({ person });
              })
            );
          }),
          catchError((error) =>
            of(PersonAPIActions.loadPersonByLoginFailure({ error }))
          )
        )
      )
    );
  });

  loadPersonByLoginFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PersonAPIActions.loadPersonByLoginFailure),
      map(() => {
        const notification = {
          content: "loadPersonByLoginFailure_message",
          level: "error"
        } as Notification;
        return NotificationActions.showNotification({ notification });
      })
    );
  });
}
